export {default as dispatch} from "./dispatch.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3/node_modules/d3-transition/node_modules/d3-dispatch/src/index.js
// module id = 903
// module chunks = 0